import { createActions, handleActions } from 'redux-actions';
import apiCall from '../api';
import equal from 'deep-equal';

let _filters = {};

const defaultState = {
  loading: true,
  swipes: [],
  total: 0,
  perPage: 40
};
const _actions = createActions({
  swipes: {
    load: filters => async (dispatch, getState) => {
      const state = getState().swipes;
      
      if (equal(_filters, filters) && state.swipes.length > 0) {
        return;
      }

      _filters = { ...filters };

      const page = parseInt(filters.page);
      const skip = page * state.perPage;
      const { type } = filters;

      dispatch(actions.setLoading(true));
      const result = await apiCall('/swipes', {
        method: 'GET',
        args: {
          skip: skip,
          limit: state.perPage,
          type,
        }
      });
      if (result.success) {
        dispatch(actions.loadDone(result.payload));
      }
      dispatch(actions.setLoading(false));
    },
    loadDone: payload => payload,
    setLoading: payload => payload
  }
});
const actions = _actions.swipes;

const setLoading = (state, action) => {
  return Object.assign({}, state, { loading: action.payload });
};
const loadDone = (state, action) => {
  return Object.assign({}, state, { ...action.payload });
};

const reducer = handleActions(
  {
    [actions.setLoading]: setLoading,
    [actions.loadDone]: loadDone
  },
  defaultState
);

export { actions, reducer };
